import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, Save } from 'lucide-react';

const NOTIFICATION_OPTIONS = [
  { key: 'email_notifications', label: 'Email Notifications', desc: 'Receive important updates via email' },
  { key: 'introduction_alerts', label: 'Introduction Alerts', desc: 'Get notified about private introduction status' },
  { key: 'portfolio_updates', label: 'Portfolio Updates', desc: 'Receive portfolio performance summaries' },
  { key: 'security_alerts', label: 'Security Alerts', desc: 'Important security notifications (recommended)' },
  { key: 'maturity_reminders', label: 'Maturity Reminders', desc: 'Get notified 7 and 3 days before investments mature' },
];

const NotificationsSection = ({ notificationPrefs, setNotificationPrefs, onSubmit, isLoading }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Bell className="w-5 h-5" />
          <span>Notification Preferences</span>
        </CardTitle>
        <CardDescription>Manage how you receive notifications</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-4">
            {NOTIFICATION_OPTIONS.map(opt => (
              <label key={opt.key} className="flex items-start space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={notificationPrefs[opt.key]}
                  onChange={(e) => setNotificationPrefs({ ...notificationPrefs, [opt.key]: e.target.checked })}
                  className="mt-1 w-4 h-4 rounded border-slate-300"
                />
                <div>
                  <div className="font-medium text-slate-900">{opt.label}</div>
                  <div className="text-sm text-slate-500">{opt.desc}</div>
                </div>
              </label>
            ))}
          </div>
          <Button type="submit" disabled={isLoading} className="w-full sm:w-auto">
            <Save className="w-4 h-4 mr-2" />
            {isLoading ? 'Saving...' : 'Save Preferences'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default NotificationsSection;
